export const SET_ERROR_API_MESSAGE = "SET_ERROR_API_MESSAGE";

export const setErrorApiMessage = (bool) => ({
	type : SET_ERROR_API_MESSAGE,
	bool
});